import { LogInIcon, LogOutIcon } from '@zhuowenli/vue-feather-icons';
import { Icon } from "../../elements";
import NetworkMixin from "../auth/network_mixin";
import ajax from "../../ajax.js";
import { eventBus, EVENTS } from "../../event_bus.js";
export default {
  name: "Users",
  mixins: [NetworkMixin],
  props: {
    current: !Object
  },
  data() {
    return {
      users: [],
      authTarget: window.envs.authTarget
    };
  },
  components: {
    Icon,
    LogInIcon,
    LogOutIcon
  },
  methods: {
    reload() {
      ajax.get(`${this.authTarget}/session`).then(response => {
        while (this.users.length) {
          this.users.pop();
        }
        if (response.data.success) {
          response.data.content.session.forEach(s => this.users.push(s));
        }
      });
    },
    useUser(user) {
      const clearUser = e => {
        console.log(e);
      };
      this.networkCreateRequestAuthToken().then(r => {
        this.networkSwitchUser({
          id: user.id,
          token: r.data.content.token
        }).then(() => {
          eventBus.$emit(EVENTS.User.Change.Success);
          eventBus.$emit(EVENTS.User.Auth.Success);
        }).catch(clearUser);
      }).catch(clearUser);
    },
    logoffUser(user) {
      this.networkLogoffUser(user).then(() => {
        eventBus.$emit(EVENTS.User.Session.Change);
      });
    }
  },
  created() {
    this.reload();
    eventBus.$on(EVENTS.User.Auth.Success, this.reload);
    eventBus.$on(EVENTS.User.Session.Change, this.reload);
  },
  destroyed() {
    eventBus.$off(EVENTS.User.Auth.Success, this.reload);
    eventBus.$off(EVENTS.User.Session.Change, this.reload);
  }
};